/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Underscore_LabelInputs */



/**
* | output |
* | --- |
* | "Underscore _" |
*
* @param {Style_Guide_Manager_Underscore_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_underscore_label = /** @type {((inputs?: Style_Guide_Manager_Underscore_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Underscore_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tiret bas _")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterstrich _")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottolineatura _")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подчеркивание _")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guión bajo _")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下划线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アンダースコア _")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंडरस्कोर _")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sublinhado _")
	return /** @type {LocalizedString} */ ("Underscore _")
});